import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Message } from 'semantic-ui-react';
import { log } from '@emyw/core-lib';
import { ButtonLink } from '@emyw/auth-lib';
import { withAppContext } from '../AppContext';

const {
    REACT_APP_FREE_PLAN_CODE: FREE,
    REACT_APP_ENJOY_SITE_ROOT_URL,
} = process.env;

class VerifiedAccount extends Component {
    state = { proceedTo: undefined }

    determineNextStep = (planCode) => {
        if (!planCode) {
            this.setState({ proceedTo: 'plan' });
        } else if (planCode === FREE) {
            this.setState({ proceedTo: 'confirm' });
        } else {
            this.setState({ proceedTo: 'payment' });
        }
    }

    render() {
        const { proceedTo } = this.state;
        if (proceedTo) {
            log.trace('this.state.proceedTo:', proceedTo);
            return <Redirect to={`/signup/${proceedTo}`} />;
        }
        const { context } = this.props;
        const { user } = context.state;
        return (
            <div style={{ maxWidth: '615px', margin: 'auto' }}>
                <Helmet>
                    <title>Enjoy Signup - Verified Account</title>
                    <meta name="description" content="Verified account" />
                </Helmet>
                <Message>
                    <Message.Header>
                        Thank you and congratulations!
                    </Message.Header>
                    {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                    <p><b>{user.email}</b> has been validated.</p>
                    {!user.signupCompletedOn && (
                        /* eslint-disable-next-line react/jsx-one-expression-per-line, max-len */
                        <div><ButtonLink onClick={() => this.determineNextStep(user.subscriptionLevelCode)}>Click here</ButtonLink> to continue the signup process.</div>
                    )}
                    {user.signupCompletedOn && (
                        /* eslint-disable-next-line react/jsx-one-expression-per-line */
                        <p><a href={`${REACT_APP_ENJOY_SITE_ROOT_URL}`}>Click here</a> to go to the home page.</p>
                    )}
                </Message>
            </div>
        );
    }
}

export default withAppContext(VerifiedAccount);
